import { Component, Inject, OnInit } from "@angular/core";
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators
} from "@angular/forms";
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef
} from "@angular/material/dialog";
import { DocumentRequestService } from "src/app/v2-node-api/services/document-request.service";
import { UserService } from "src/shared/services/user/user.service";
import { DialogSelectUserComponent } from "../../+my-libraries/+sites/document-library/shared/dialog-select-user/dialog-select-user.component";
import {
  DocumentRequestInterface,
  DocumentRequestStatus
} from "../models/document-request.model";
import { V2nodeApiService } from "src/shared/services/v2node-api.service";
import { Title } from "@angular/platform-browser";

@Component({
  selector: "dialog-add-document-request",
  templateUrl: "./dialog-add-document-request.component.html",
  styleUrls: ["./dialog-add-document-request.component.scss"]
})
export class DialogAddDocumentRequestComponent implements OnInit {
  dynamicForm: FormGroup;
  submitted = false;
  templates: any[] = [];
  public selected2: any = null;
  public loading: boolean;
  public isHidden = false;
  public users: any[];
  public listuser: any[];
  public userids: string[] = [];
  public useremails: string[] = [];
  public inheritedPermissions: any[];
  public permissions: any[];
  public isInherited: boolean;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<DialogAddDocumentRequestComponent>,
    private formBuilder: FormBuilder,
    private dialog: MatDialog,
    protected userService: UserService,
    protected documentRequestService: DocumentRequestService,
    private v2node: V2nodeApiService
  ) { }

  get f() {
    return this.dynamicForm.controls;
  }

  get t() {
    return this.dynamicForm.get("documents") as FormArray;
  }

  get sizeDocuments() {
    return (this.dynamicForm.get("documents") as FormArray).length;
  }

  ngOnInit() {
    this.inheritedPermissions = [];
    this.permissions = [];
    this.listuser = [];
    this.dynamicForm = this.formBuilder.group({
      title: ["", Validators.required],
      documents: new FormArray([]),
      select: [""],
      expireDate:[""]
    });
  }

  onChangeDocuments(e) {
    const numberOfDocuments = e.target.value || 0;
    if (this.sizeDocuments < numberOfDocuments) {
      for (let i = this.sizeDocuments; i < numberOfDocuments; i++) {
        this.t.controls.push(new FormControl(["", Validators.required]));
      }
    } else {
      for (let i = this.sizeDocuments; i >= numberOfDocuments; i--) {
        this.t.removeAt(i);
      }
    }
  }

  openDialog() {
    const dialogRef = this.dialog.open(DialogSelectUserComponent, {
      width: "70%",
      height: "55%",
      data: this.userService.user.company
    });

    dialogRef.afterClosed().subscribe(result => {
      if (!result || !result.length) {
        return;
      }

      this.listuser = [...this.listuser, ...result];
    });
  }

  async onSubmit() {
    const userids = this.listuser.map(user => {
      if (user.properties["cm:authorityName"] != null) {
        return user.properties["cm:authorityName"];
      } else {
        return user.properties["cm:owner"].id;
      }

    });
    const useremails = this.listuser.map(user => {
      return user.properties["cm:email"];
    });

    const receiversArray = this.listuser.map(u => ({
      email: u.properties['cm:email'] || null,
      type: u.nodeType,
      id: u.properties["cm:authorityName"] ? u.id : u.properties["cm:owner"].id
    }));
   
    if (this.isHidden) {
      const documents = [];
      if (this.dynamicForm.value.select) {
        this.dynamicForm.value.select.documents.forEach(element => {
         
          const datas = {
            title: element.name,
            status:'pending'
          };
          if(!element.ishidden){
            documents.push(datas);
          }
          
        });
      }

      var data: DocumentRequestInterface = {
        title: this.dynamicForm.value.title,
        expireDate:this.dynamicForm.value.expireDate ?  this.dynamicForm.value.expireDate.toISOString() :"",
        type:this.dynamicForm.value.select.templateName,
        documents: documents,
        receiver: userids.join(),
        receivermails: useremails.join(),
        sender: this.userService.user.id,
        sendermail: this.userService.user.email,
        container: this.data.actualNode,
        status: DocumentRequestStatus.PENDING,
        receiversArray
      };
    } else {
      var data: DocumentRequestInterface = {
        title: this.dynamicForm.value.title,
        expireDate:this.dynamicForm.value.expireDate ?  this.dynamicForm.value.expireDate.toISOString() :"",
        documents: this.t.value.map(el => ({ title: el,status:'pending' })),
        receiver: userids.join(),
        receivermails: useremails.join(),
        sender: this.userService.user.id,
        sendermail: this.userService.user.email,
        container: this.data.actualNode,
        status: DocumentRequestStatus.PENDING,
        receiversArray
      };
      var datas = this.t.value.map(el => ({ title: el,status:'pending' }));
    }

    this.documentRequestService.create(data).subscribe(res => {
      this.dialogRef.close(res);
    });
  }

  removePermission(i: number) {
    this.listuser.splice(i, 1);
  }

  addDoc() {
    this.t.push(new FormControl("", Validators.required));
  }

  removeDoc(i: number) {
    this.t.removeAt(i);
  }

  async toggle() {
    this.isHidden = !this.isHidden;
    if (this.isHidden) {
      this.templates = await this.v2node.requestApi({
        action: "/document-request-template"
      });
      if (this.templates.length) {
        this.selected2 = this.templates[0];
      }
    }
  }

  hideDocument(doc,index){
    this.dynamicForm.value.select.documents[index].ishidden=true;
   
  }
  showDocument(doc,index){
    this.dynamicForm.value.select.documents[index].ishidden=false;
  }
}
